import Header from "../Header";
import Footer from "../Footer";
import Breadcrumbs from "../Breadcrumbs";import BannerImg from "../assets/Images/hkasharmony.png";

import BottomLogoImg from "../assets/Images/bottom-logo.png";
import Img1 from "../assets/ceremonyPics2019/0.jpg";
import Img2 from "../assets/ceremonyPics2019/2.jpg";
import Img3 from "../assets/ceremonyPics2019/3.jpg";
import Img4 from "../assets/ceremonyPics2019/4.jpg";
import Img5 from "../assets/ceremonyPics2019/5.jpg";
import Img6 from "../assets/ceremonyPics2019/6.jpg";
import Img7 from "../assets/ceremonyPics2019/7.jpg";
import Img8 from "../assets/ceremonyPics2019/8.jpg";
import Img9 from "../assets/ceremonyPics2019/9.jpg";
import Img10 from "../assets/ceremonyPics2019/10.jpg";
import Img11 from "../assets/ceremonyPics2019/11.jpg";
import Img12 from "../assets/ceremonyPics2019/12.jpg";
import Img13 from "../assets/ceremonyPics2019/13.jpg";
import Img14 from "../assets/ceremonyPics2019/14.jpg";
import Img15 from "../assets/ceremonyPics2019/15.jpg";
import Img16 from "../assets/ceremonyPics2019/16.jpg";
import Img17 from "../assets/ceremonyPics2019/17.jpg";
import Img18 from "../assets/ceremonyPics2019/18.jpg";
import Img19 from "../assets/ceremonyPics2019/19.jpg";
import Img20 from "../assets/ceremonyPics2019/20.jpg";
import Img21 from "../assets/ceremonyPics2019/21.jpg";
import Img22 from "../assets/ceremonyPics2019/22.jpg";
import Img23 from "../assets/ceremonyPics2019/23.jpg";
import Img24 from "../assets/ceremonyPics2019/24.jpg";
import Img25 from "../assets/ceremonyPics2019/25.jpg";
import Img26 from "../assets/ceremonyPics2019/26.jpg";
import Img27 from "../assets/ceremonyPics2019/27.jpg";
import Img28 from "../assets/ceremonyPics2019/28.jpg";
import Img29 from "../assets/ceremonyPics2019/29.jpg";
import Img30 from "../assets/ceremonyPics2019/30.jpg";
import Img31 from "../assets/ceremonyPics2019/31.jpg";
import Img32 from "../assets/ceremonyPics2019/32.jpg";
import Img33 from "../assets/ceremonyPics2019/33.jpg";
import Img34 from "../assets/ceremonyPics2019/34.jpg";
import Img35 from "../assets/ceremonyPics2019/35.jpg";
import Img36 from "../assets/ceremonyPics2019/36.jpg";
import Img37 from "../assets/ceremonyPics2019/37.jpg";
import Img38 from "../assets/ceremonyPics2019/38.jpg";
import Img39 from "../assets/ceremonyPics2019/39.jpg";
import Img40 from "../assets/ceremonyPics2019/40.jpg";
import Img41 from "../assets/ceremonyPics2019/41.jpg";
import Img42 from "../assets/ceremonyPics2019/42.jpg";
import Img43 from "../assets/ceremonyPics2019/43.jpg";
import Img44 from "../assets/ceremonyPics2019/44.jpg";
import Img45 from "../assets/ceremonyPics2019/45.jpg";
import Img46 from "../assets/ceremonyPics2019/46.jpg";
import Img47 from "../assets/ceremonyPics2019/47.jpg";
import Img48 from "../assets/ceremonyPics2019/48.jpg";
import Img49 from "../assets/ceremonyPics2019/49.jpg";
import Img50 from "../assets/ceremonyPics2019/50.jpg";
import Img51 from "../assets/ceremonyPics2019/51.jpg";
import Img52 from "../assets/ceremonyPics2019/52.jpg";
import Img53 from "../assets/ceremonyPics2019/53.jpg";
import Img54 from "../assets/ceremonyPics2019/54.jpg";
import Img55 from "../assets/ceremonyPics2019/55.jpg";
import Img56 from "../assets/ceremonyPics2019/56.jpg";
import Img57 from "../assets/ceremonyPics2019/57.jpg";
import Img58 from "../assets/ceremonyPics2019/58.jpg";
import Img59 from "../assets/ceremonyPics2019/59.jpg";
import Img60 from "../assets/ceremonyPics2019/60.jpg";
import Img61 from "../assets/ceremonyPics2019/61.jpg";
import Img62 from "../assets/ceremonyPics2019/62.jpg";
import Img63 from "../assets/ceremonyPics2019/63.jpg";
import Img64 from "../assets/ceremonyPics2019/64.jpg";
import Img65 from "../assets/ceremonyPics2019/65.jpg";
import Img66 from "../assets/ceremonyPics2019/66.jpg";
import Img67 from "../assets/ceremonyPics2019/67.jpg";
import Img68 from "../assets/ceremonyPics2019/68.jpg";
import Img69 from "../assets/ceremonyPics2019/69.jpg";
import Img70 from "../assets/ceremonyPics2019/70.jpg";
import Img71 from "../assets/ceremonyPics2019/71.jpg";
import Img72 from "../assets/ceremonyPics2019/72.jpg";
import Img73 from "../assets/ceremonyPics2019/73.jpg";
import Img74 from "../assets/ceremonyPics2019/74.jpg";
import Img75 from "../assets/ceremonyPics2019/75.jpg";
import Img76 from "../assets/ceremonyPics2019/76.jpg";
import Img77 from "../assets/ceremonyPics2019/77.jpg";
import Img78 from "../assets/ceremonyPics2019/78.jpg";
import Img79 from "../assets/ceremonyPics2019/79.jpg";
import Img80 from "../assets/ceremonyPics2019/80.jpg";
import Img81 from "../assets/ceremonyPics2019/81.jpg";
import Img82 from "../assets/ceremonyPics2019/82.jpg";
import Img83 from "../assets/ceremonyPics2019/83.jpg";
import Img84 from "../assets/ceremonyPics2019/84.jpg";
import Img85 from "../assets/ceremonyPics2019/85.jpg";
import Img86 from "../assets/ceremonyPics2019/86.jpg";
import Img87 from "../assets/ceremonyPics2019/87.jpg";
import Img88 from "../assets/ceremonyPics2019/88.jpg";
import Img89 from "../assets/ceremonyPics2019/89.jpg";
import Img90 from "../assets/ceremonyPics2019/90.jpg";
import Img91 from "../assets/ceremonyPics2019/91.jpg";
import Img92 from "../assets/ceremonyPics2019/92.jpg";
import Img93 from "../assets/ceremonyPics2019/93.jpg";
import Img94 from "../assets/ceremonyPics2019/94.jpg";
import Img95 from "../assets/ceremonyPics2019/95.jpg";
import Img96 from "../assets/ceremonyPics2019/96.jpg";
import Img97 from "../assets/ceremonyPics2019/97.jpg";
import Img98 from "../assets/ceremonyPics2019/98.jpg";
import Img99 from "../assets/ceremonyPics2019/99.jpg";
import Img100 from "../assets/ceremonyPics2019/100.jpg";
import Img101 from "../assets/ceremonyPics2019/101.jpg";
import Img102 from "../assets/ceremonyPics2019/102.jpg";
import Img103 from "../assets/ceremonyPics2019/103.jpg";
import Img104 from "../assets/ceremonyPics2019/104.jpg";
import Img105 from "../assets/ceremonyPics2019/105.jpg";
import Img106 from "../assets/ceremonyPics2019/106.jpg";
import Img107 from "../assets/ceremonyPics2019/107.jpg";
import Img108 from "../assets/ceremonyPics2019/108.jpg";
import Video2019 from "../assets/Videos/2019.mp4";
import HarmonyImage from "../assets/Images/Harmony-image.png";
import "./RecognitionCeremonyReviewPage.scss";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const RecognitionPage2019 = () => {
  const { t } = useTranslation();

  return (
    <>
      <Header />
      <div className="banner">
        <img src={BannerImg} alt="" />
        <div className="banner_title res">
          <a style={{ color:'white', fontSize:'70px', fontWeight:'700', lineHeight:'77px', marginBottom:'30px', borderBottom: '3px solid #b42b3d' }}>{t("recognition_ceremony_page_header")}</a>
          <p style={{ color:'white', fontSize:'32px', fontWeight:'700', lineHeight:'22px', marginBottom:'26px', marginTop:'30px' }}>{t("recognition_ceremony_page_header2")}</p>
        </div>
      </div>
      <Breadcrumbs>
        <Link>{t("breadcrumbs_recognition_ceremony_page_link1")}</Link>
        <span>{t("breadcrumbs_recognition_ceremony_page_span")}</span>
        <Link>{t("breadcrumbs_recognition_ceremony_page_link2")}</Link>
      </Breadcrumbs>
      <div className="main-container-recognition_ceremony">
        <div className="year-links">
        <Link to="/recognitionceremonyreview2019">{t("recognition_ceremony_page_text3")}</Link>
        <Link to="/recognitionceremonyreview">{t("recognition_ceremony_page_text2")}</Link>
        </div>
        <div className="harmony-text-image-section">
          <p>{t("recognition_ceremony_page_text1")}</p>
          <img src={HarmonyImage} alt="" />
        </div>
        <div className="video-section">
          <video id="video-2019" controls src={Video2019}></video>
        </div>
        <div className="grid-images-section">
          <img src={Img1} alt="" />
          <img src={Img2} alt="" />
          <img src={Img3} alt="" />
          <img src={Img4} alt="" />
          <img src={Img5} alt="" />
          <img src={Img6} alt="" />
          <img src={Img7} alt="" />
          <img src={Img8} alt="" />
          <img src={Img9} alt="" />
          <img src={Img10} alt="" />
          <img src={Img11} alt="" />
          <img src={Img12} alt="" />
          <img src={Img13} alt="" />
          <img src={Img14} alt="" />
          <img src={Img15} alt="" />
          <img src={Img16} alt="" />
          <img src={Img17} alt="" />
          <img src={Img18} alt="" />
          <img src={Img19} alt="" />
          <img src={Img20} alt="" />
          <img src={Img21} alt="" />
          <img src={Img22} alt="" />
          <img src={Img23} alt="" />
          <img src={Img24} alt="" />
          <img src={Img25} alt="" />
          <img src={Img26} alt="" />
          <img src={Img27} alt="" />
          <img src={Img28} alt="" />
          <img src={Img29} alt="" />
          <img src={Img30} alt="" />
          <img src={Img31} alt="" />
          <img src={Img32} alt="" />
          <img src={Img33} alt="" />
          <img src={Img34} alt="" />
          <img src={Img35} alt="" />
          <img src={Img36} alt="" />
          <img src={Img37} alt="" />
          <img src={Img38} alt="" />
          <img src={Img39} alt="" />
          <img src={Img40} alt="" />
          <img src={Img41} alt="" />
          <img src={Img42} alt="" />
          <img src={Img43} alt="" />
          <img src={Img44} alt="" />
          <img src={Img45} alt="" />
          <img src={Img46} alt="" />
          <img src={Img47} alt="" />
          <img src={Img48} alt="" />
          <img src={Img49} alt="" />
          <img src={Img50} alt="" />
          <img src={Img51} alt="" />
          <img src={Img52} alt="" />
          <img src={Img53} alt="" />
          <img src={Img54} alt="" />
          <img src={Img55} alt="" />
          <img src={Img56} alt="" />
          <img src={Img57} alt="" />
          <img src={Img58} alt="" />
          <img src={Img59} alt="" />
          <img src={Img60} alt="" />
          <img src={Img61} alt="" />
          <img src={Img62} alt="" />
          <img src={Img63} alt="" />
          <img src={Img64} alt="" />
          <img src={Img65} alt="" />
          <img src={Img66} alt="" />
          <img src={Img67} alt="" />
          <img src={Img68} alt="" />
          <img src={Img69} alt="" />
          <img src={Img70} alt="" />
          <img src={Img71} alt="" />
          <img src={Img72} alt="" />
          <img src={Img73} alt="" />
          <img src={Img74} alt="" />
          <img src={Img75} alt="" />
          <img src={Img76} alt="" />
          <img src={Img77} alt="" />
          <img src={Img78} alt="" />
          <img src={Img79} alt="" />
          <img src={Img80} alt="" />
          <img src={Img81} alt="" />
          <img src={Img82} alt="" />
          <img src={Img83} alt="" />
          <img src={Img84} alt="" />
          <img src={Img85} alt="" />
          <img src={Img86} alt="" />
          <img src={Img87} alt="" />
          <img src={Img88} alt="" />
          <img src={Img89} alt="" />
          <img src={Img90} alt="" />
          <img src={Img91} alt="" />
          <img src={Img92} alt="" />
          <img src={Img93} alt="" />
          <img src={Img94} alt="" />
          <img src={Img95} alt="" />
          <img src={Img96} alt="" />
          <img src={Img97} alt="" />
          <img src={Img98} alt="" />
          <img src={Img99} alt="" />
          <img src={Img100} alt="" />
          <img src={Img101} alt="" />
          <img src={Img102} alt="" />
          <img src={Img103} alt="" />
          <img src={Img104} alt="" />
          <img src={Img105} alt="" />
          <img src={Img106} alt="" />
          <img src={Img107} alt="" />
          <img src={Img108} alt="" />
        </div>
      </div>
      <div className="temporary">
        <img src={BottomLogoImg} alt="" />
      </div>

      <Footer />
    </>
  );
};

export default RecognitionPage2019;
